import { setCookie } from "../CookieHelper";
import { COOKIE_ENUM } from "../enums";
import { refreshSocketAuth } from "../socket";
import { getVisitorToken } from "./APICalls";

export const CREATE_VISITOR_PATH = "user/create-visitor";

let pendingVisitorToken: Promise<string> | null = null;

/**
 * Issues a visitor token and stores it, sharing one request between every
 * caller that asks while it is in flight.
 *
 * A page load fires many requests at once; when the token is missing or dead
 * they all 401 together. Each one used to call create-visitor on its own, and
 * the slower responses overwrote (or the later 401s deleted) the token the
 * faster ones had just stored — a session could make ~150 create-visitor calls
 * in a minute and still end up sending requests with no token at all.
 */
export const ensureVisitorToken = (): Promise<string> => {
  if (!pendingVisitorToken) {
    pendingVisitorToken = getVisitorToken()
      .then((res) => {
        const token: string = res.data.token;
        setCookie(COOKIE_ENUM.TOKEN, token);
        refreshSocketAuth();

        return token;
      })
      .finally(() => {
        pendingVisitorToken = null;
      });
  }

  return pendingVisitorToken;
};
